import { Messages } from '../../codegen/Localize';
import { IMetricInfo } from '../models/IMetricInfo';
import { Module } from '../../ts/Module';
import { Metrics } from '../resources/Metrics';
import { Views } from '../../ts/resources/Views';
import { IViewActions } from '../../ts/ServerApi/types/IViewActions';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';

export class ResumeMetricAction {

  public static $inject = ['$translate', 'Views', 'Metrics'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private views: Views,
    private metrics: Metrics) { }

  public async resumeMetric(metric: IMetricInfo) {
    const viewId = metric.connectedView && metric.connectedView.viewId;
    if (!viewId) {
      throw new Error(Messages.metricResumeErrorMessage());
    }

    const result = await this.metrics.resumeMetrics([metric.id]);
    if (!result.errors) {
      ToasterService.instance.pop({
        type: ToastType.Success,
        text: this.$translate.instant('metricResumeSuccess', {
          METRIC_NAME: metric.name,
        }),
        testId: 'resume-metric-success'
      });
    } else {
      throw new Error(Messages.metricResumeErrorMessage());
    }
  }
}

Module.instance().service('ResumeMetricAction', ResumeMetricAction);
